import {Component, OnInit} from '@angular/core';
import {HttpService} from '../service/http.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-news-list-only',
  templateUrl: './news-list-only.component.html',
  styleUrls: ['./news-list-only.component.css']
})
export class NewsListOnlyComponent implements OnInit {
  noNewsList: boolean;
  noWorldNewsList: boolean;
  // newsList: any;
  worldNewsList: any;
  currentLang: any = sessionStorage.getItem('lang');

  newsList = [
    {
      id: 2,
      image: 'assets/imgs/mongolia/3.jpeg',
      published: new Date('2024-11-19'),
      title: '2025 жылғы 16-26 мамыр аралығында \n' +
        'Өлгий (Моңғолия) қаласында тоғызқұмалақтан 11, 13, 15, 17 жасқа дейінгі ұлдар мен қыздар арасында халықаралық жарыс өтті.\n' +
        'Оған Ресей Федерациясы, Өзбекістан, Моңғолия, Қазақстан елдерінен спортшылар қатысты.\n' +
        'Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы өткізді.\n' +
        'Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Самұрық-Қазына қоры мен Спорты қолдау қоры демеушілік қолдау көрсетті.'
    },
    {
      id: 1,
      image: 'assets/imgs/korea/1.jpeg',
      published: new Date('2024-11-19'),
      title: '2025 жылғы 24-30 маусым аралығында Оңтүстік Кореяның Сеул қаласында тоғызқұмалақтан халықаралық турнир өтуде.\n' +
        'Жарысқа ерлер мен әйелдер арасында Оңтүстік Корея, Моңғолия, Үндістан және Қазақстан елдерінің спортшылары қатысуда.\n' +
        'Тоғызқұмалақтан ҚР Ұлттық құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Самұрық-Қазына қоры мен Спортты қолдау қоры демеушілік қолдау көрсетуде.'
    },
    {
      id: 3,
      image: 'assets/imgs/korea/2.jpeg',
      published: new Date('2024-11-19'),
      title: '2025 жылғы 24-30 маусым аралығында Оңтүстік Кореяның Сеул қаласында тоғызқұмалақтан халықаралық турнир өтті. Жарысқа Оңтүстік Корея, Қазақстан, Моңғолия және Үндістан елдерінің спортшылары қатысты.\n' +
        'Тоғызқұмалақтан ҚР ұлттық құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Самұрық-Қазына қоры мен Спортты қолдау қоры демеушілік қолдау көрсетті.'
    },
    {
      id: 6,
      image: 'assets/imgs/turkey/2.jpeg',
      published: new Date('2024-12-30'),
      title: '2024 жылғы 20-30 желтоқсан аралығында Анкара (Турция) қаласында тоғызқұмалақтан 13, 15, 17 жасқа дейінгі ұлдар мен қыздар арасында халықаралық жарыс өтті. Оған: Турция, Молдова, Румыния, Қазақстан елдерінен спортшылар қатысты. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы өткізді. Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетті.'
    },
    {
      id: 8,
      image: 'assets/imgs/turkey/1.jpeg',
      published: new Date('2024-12-30'),
      title: '2024 жылғы 20-30 желтоқсан аралығында Түркияның Анкара қаласында тоғызқұмалақтан халықаралық турнир өтуде. Жарысқа 13, 15, 17 жасқа дейінгі Түркия, Молдова, Румыния, Қазақстан елдерінің спортшылары қатысуда. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы және Мангала Федерациясы бірігіп өткізуде. Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетуде.'
    },
    {
      id: 7,
      image: 'assets/imgs/czhecia/1.jpeg',
      published: new Date('2024-12-16'),
      title: '2024 жылғы 6-16 желтоқсан аралығында Чехияның Прага қаласында тоғызқұмалақтан халықаралық турнир өтуде. Жарысқа 13, 15, 17 жасқа дейінгі Чехия, Испания, Венгрия, Польша, Қазақстан елдерінің спортшылары қатысуда. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы өткізуде. Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетуде.'
    },
    {
      id: 9,
      image: 'assets/imgs/czhecia/2.jpeg',
      published: new Date('2024-12-16'),
      title: '2024 жылғы 6-16 желтоқсан аралығында Прага (Чехия) қаласында тоғызқұмалақтан 13, 15, 17 жасқа дейінгі ұлдар мен қыздар арасында халықаралық жарыс өтті. Оған Чехия, Испания, Венгрия, Польша, Қазақстан елдерінен спортшылар қатысты. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы өткізді. Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетті.'
    },
    {
      id: 41,
      image: 'assets/imgs/kyrgyzstan/1.jpeg',
      published: new Date('2024-12-12'),
      title: '2024 жылғы 5-12 желтоқсан аралығында Қырғызстан Республикасының Бішкек қаласында тоғызқұмалақтан Ч.Айтматовты еске алуға арналған халықаралық турнир өтуде. Жарысқа Қазақстан, Қырғызстан, Өзбекстан және Ресей елдерінен 235 спортшы қатысуда. Жарыс ардагерлер, ерлер мен әйелдер, U-15 ұлдар мен қыздар арасында өтуде.\n' +
        'Тоғызқұмалақтан ҚР ұлттық құрама командасының іссапарына Қазақстан Республикасының Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетуде.\n'
    },
    {
      id: 10,
      image: 'assets/imgs/kyrgyzstan/2.jpeg',
      published: new Date('2024-12-12'),
      title: '2024 жылғы 5-12 желтоқсан аралығында Қырғызстанның Бішкек қаласында тоғызқұмалақтан халықаралық турнир өтті. Жарысқа Қырғызстан, Өзбекстан, Ресей, Қазақстан елдерінен 235 спортшы қатысты. Тоғызқұмалақтан ҚР ұлттық құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory  демеушілік қолдау көрсетті.'
    },
    {
      id: 51,
      image: 'assets/imgs/columbia/2.jpeg',
      published: new Date('2024-11-30'),
      title: 'Колумбияда тоғызқұмалақтан халықаралық турнир өтті: Қазақстан құрамасы жүлделі оралды'
    },
    {
      id: 11,
      image: 'assets/imgs/columbia/1.jpeg',
      published: new Date('2024-11-30'),
      title: '2024 жылғы 22-30 қараша аралығында Колумбияның Кали қаласында тоғызқұмалақтан халықаралық турнир өтуде. Жарысқа ерлер мен әйелдер арасында Колумбия, Бразилия, Мексика, Эквадор, Аргентина, Чили, Гватемала, Панама, Венесуэла, Германия Қазақстан елдерінің спортшылары қатысуда. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы өткізуде. \n' +
        'Тоғызқұмалақтан ҚР ұлттық құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетуде. Жарыстың бас демеушісі - Kazpetrol Group.\n'
    },
    {
      id: 65,
      image: 'assets/imgs/mongolia/2.jpeg',
      published: new Date('2024-11-19'),
      title: '2024 жылғы 10-19 қараша аралығында Улан-Батор (Моңғолия) қаласында тоғызқұмалақтан 13, 15, 17 жасқа дейінгі ұлдар мен қыздар арасында халықаралық жарыс өтті. Оған Қазақстан, Моңғолия, Ресей, Өзбекстаннан елдерінен 31 спортшы қатысты. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы мен Моңғолия Тоғызқұмалақ Федерациясы бірлесіп өткізді. Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory демеушілік қолдау көрсетті.'
    },
    {
      id: 66,
      image: 'assets/imgs/mongolia/1.jpeg',
      published: new Date('2024-11-19'),
      title: '2024 жылғы 10-19 қараша аралығында Моңғолияның Улан-Батор қаласында тоғызқұмалақтан халықаралық турнир өтуде. Жарысқа 13, 15, 17 жасқа дейінгі Моңғолия, Қазақстан, Ресей, Өзбекстан елдерінің спортшылары (офлайн/онлайн) қатысуда. Жарысты Дүниежүзілік Тоғызқұмалақ Федерациясы мен Моңғолия Тоғызқұмалақ Федерациясы бірлесіп өткізуде. Тоғызқұмалақтан ҚР жасөспірімдер құрама командасының іссапарына ҚР Туризм және спорт министрлігі, Sport Qory қолдау көрсетуде.'
    },

  ];



  constructor(private http: HttpService,
              private router: Router,
              public translate: TranslateService) {
  }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe((res) => {
      if (this.currentLang !== res.lang) {
        this.currentLang = res.lang;
        this.getNewsByCity();
        this.getNewsByCountry();
      }
    });
    this.getNewsByCity();
    this.getNewsByCountry();
  }

  getNewsByCountry() {
    this.http.getWorldNewsWithoutContent(this.currentLang).subscribe((data: any) => {
      if (data.length === 0) {
        this.noWorldNewsList = true;
      } else {
        this.worldNewsList = data;
        this.worldNewsList.forEach(news => {news.type = 'country'})
      }
    });
  }

  getNewsByCity() {
    this.http.getKazNewsWithoutContent(this.currentLang).subscribe((data: any) => {
      if (data.length === 0) {
        this.noNewsList = true;
      } else {
        this.newsList = data;
        // this.newsList.forEach(news => {news.type = 'city'})
      }
    });
  }

  redirectNewsPage(item) {
    this.router.navigate(['/news', item.id]);
  }

}
